<template>
  <ya-site-resource-list resource="room" />
</template>

<script>
import YaSiteResourceList from './resourceList'

export default {
  name: 'YaSiteRoomTypeList',
  components: { YaSiteResourceList },
}
</script>
